import { PRIMARY_NAV_HEIGHT } from '@/components/navigation/PrimaryNavigation';
import { COLORS } from '@/styles/color';
import { BREAKPOINT_PADDING, BREAKPOINTS } from '@/styles/layout';
import { FONT_FAMILIES } from '@/styles/typography';
import { BASE_FONT_SIZE } from '@/styles/typography/base';
import { remCalc } from '@/styles/typography/utils';
import styled, { createGlobalStyle, css } from 'styled-components';
import fontimports from './typography/font-imports';

export default createGlobalStyle`
  :root {
    --breakpoint-all-active: ${Object.keys(BREAKPOINTS)[0]};
    --breakpoint-current: ${Object.keys(BREAKPOINTS)[0]};
    --breakpoint-padding-x: ${Object.values(BREAKPOINT_PADDING)[0]}px;
    --breakpoint-x: ${Object.values(BREAKPOINTS)[0]}px;

    /* Variables */
    ${Object.keys(BREAKPOINTS).map((key, index, arr) => {
  if (index === 0) return;

  const width = BREAKPOINTS[key];
  const padding = BREAKPOINT_PADDING[key];

  return css`
        @media (min-width: ${width}px) {
          --breakpoint-all-active: ${arr.slice(0, index + 1).join(', ')};
          --breakpoint-current: ${key};
          --breakpoint-padding-x: ${padding}px;
          --breakpoint-x: ${width}px;
        }
      `;
})}
    
    scroll-padding-top: ${remCalc(PRIMARY_NAV_HEIGHT + BASE_FONT_SIZE)};

    /* Base */
    font-size: ${BASE_FONT_SIZE}px;
    font-family: ${FONT_FAMILIES.SANS_SERIF};
    font-feature-settings: 'tilt', 'salt', 'ss04';
    color: ${COLORS.BLACK};

    /* Optimizely Hide */
    will-change: opacity;
    opacity: 1;
    transition: opacity 0.25s ease-in-out;
    transition-delay: 0.1s;

    &.hide {
      opacity: 0;
      transition-delay: 0s;
      transition-duration: 0s;
    }
  }

  ${fontimports}
  
  body {
    will-change: background-color;
    transition: background-color 400ms linear;
    background-color: var(--body-background-color, ${COLORS.WHITE});
  }
`;

export const LoadingState = createGlobalStyle`
  :root * {
    cursor: progress !important;
  }
`;

export const ChiliPiperTarget = styled.div`
background-color: ${COLORS.WHITE};

.chilipiper-popup {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 999;
  background: ${COLORS.WHITE};
  border-radius: 10px;

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  .chilipiper-close {
    display: none;
  }

  .chilipiper-popup-window {
    max-width: none !important; // inline style override
    max-height: none !important; // inline style override
    width: 100% !important; // inline style override
    height: 100% !important; // inline style override
    border-radius: 0 !important; // inline style override
    background: transparent;

    .routing-loader {
      position: absolute;
      width: inherit;
      max-width: inherit;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: -50px;

      .routing-loader-body {
        display: flex;
        flex-direction: column;
        align-items: center;

        span {
          margin-bottom: 40px;
          font-weight: 500;
          font-size: 18px;
          color: #808284;
        }
      }
    }
  }

  .chilipiper-frame {
    overflow: hidden;
    border-radius: 0 !important;
    width: 100%;
    height: 100%;
    min-width: 100%;
  }

  .fabe-first-loading-label {
    margin-top: 30px;
    margin-left: 30px;
    display: block;
  }

  .chilipiper-popup-loading {
    width: 50px;
    height: 50px;
    background-image: url('https://js.chilipiper.com/images/loading.gif');
    background-size: 100%;
  }

  [data-chili-css='loader-dot'] {
    width: 1rem;
    height: 1rem;
    background: rgba(38, 52, 64, 0.32);

    &.dot1,
    &.dot2,
    &.dot3 {
      border-radius: 100%;
      display: inline-block;
      animation: bounce 1.4s infinite ease-in-out both;
    }

    &.dot1 {
      animation-delay: -0.32s;
    }

    &.dot2 {
      animation-delay: -0.16s;
    }
  }
}

@keyframes bounce {
  0%,
  80%,
  100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1);
  }
}
`;
